import { httpService } from '../utility/httpService';
import { API_BASE } from '../config/env';
import { httpConstants } from '../constants';

export interface VideoResponse {
  id: string;
  name?: string;
  video_url: string | null;
  thumbnail_url: string | null;
}

interface VideoAPIResponse {
  solution_id?: string;
  solution_name?: string;
  solution_video_url?: string | null;
  agent_id?: string;
  agent_name?: string;
  agent_video_url?: string | null;
  thumbnail_url?: string | null;
}

function getAuthHeaders(): Record<string, string> | undefined {
  const token =
    document.cookie
      .split('; ')
      .find((row) => row.startsWith('auth-token='))
      ?.split('=')[1] || '';

  return token ? { Authorization: `Bearer ${token}` } : undefined;
}

/**
 * Fetch solution video by solution ID
 */
export const getSolutionVideoById = async (id: string): Promise<VideoResponse> => {
  const url = `${API_BASE}/api/v1/solution/${id}/video/`;

  try {
    const res = await httpService<VideoAPIResponse>(
      httpConstants.METHOD_TYPE.GET,
      url,
      undefined,
      getAuthHeaders()
    );

    return {
      id: res.solution_id ?? '',
      name: res.solution_name ?? '',
      video_url: res.solution_video_url ?? null,
      thumbnail_url: res.thumbnail_url ?? null,
    };
  } catch {
    return {
      id: '',
      name: '',
      video_url: null,
      thumbnail_url: null,
    };
  }
};

/**
 * Fetch agent video by agent ID
 */
export const getAgentVideoById = async (id: string): Promise<VideoResponse> => {
  const url = `${API_BASE}/api/v1/agent/${id}/video/`;

  try {
    const res = await httpService<VideoAPIResponse>(
      httpConstants.METHOD_TYPE.GET,
      url,
      undefined,
      getAuthHeaders()
    );

    return {
      id: res.agent_id ?? '',
      name: res.agent_name ?? '',
      video_url: res.agent_video_url ?? null,
      thumbnail_url: res.thumbnail_url ?? null,
    };
  } catch {
    return {
      id: '',
      name: '',
      video_url: null,
      thumbnail_url: null,
    };
  }
};

/**
 * Fetch solution video by solution name (for ZBrain-based lookup)
 */
export const getSolutionVideoByName = async (solutionName: string): Promise<VideoResponse> => {
  const url = `${API_BASE}/api/v1/solution/video?solution_name=${encodeURIComponent(solutionName)}`;

  try {
    const res = await httpService<VideoAPIResponse>(
      httpConstants.METHOD_TYPE.GET,
      url,
      undefined,
      getAuthHeaders()
    );

    return {
      id: res.solution_id ?? '',
      name: res.solution_name ?? solutionName,
      video_url: res.solution_video_url ?? null,
      thumbnail_url: res.thumbnail_url ?? null,
    };
  } catch {
    return {
      id: '',
      name: '',
      video_url: null,
      thumbnail_url: null,
    };
  }
};
